import { AppAction, AppActionType } from "../actions";
import { AppStateType } from "../state";

const AppReducer = (state: AppStateType, action: AppAction): AppStateType => {
  switch (action.type) {
    case AppActionType.UPDATE_CONTACT_FORM_DETAILS: {
      return {
        ...state,
        contactFormDetails: action.payload,
      };
    }
    case AppActionType.SET_SELECTED_CITY: {
      return {
        ...state,
        selectedCity: action.payload,
      };
    }
    default:
      return state;
  }
};

export { AppReducer };
